import { Component, Input, OnInit } from '@angular/core';
import { SetFeature } from 'src/app/shared/models/node';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';

@Component({
  selector: 'app-sample-feature',
  templateUrl: './sample-feature.component.html',
  styleUrls: ['./sample-feature.component.scss']
})
export class SampleFeatureComponent implements OnInit {

  @Input() block: SetFeature[] = [];
  @Input() column: string = '';
  public classColumn: string = '';


  constructor(
    public nodeService: NodeService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void { this.setColumnItem(); }


  setColumnItem() {
    switch (this.column) {
      case '2':
        this.classColumn = 'col-sm-5 col-12';
        break;
      case '3':
        this.classColumn = 'col-md-3 col-sm-5 col-12';
        break;
      case '4':
        this.classColumn = 'col-lg-3 col-md-3 col-sm-5 col-12';
        break;
      default:
        this.classColumn = 'col-12';
        break;
    }
  }

}
